/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Ctaband_SubInputs */

const en_vc_ctaband_sub = /** @type {(inputs: Vc_Ctaband_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free, open source, and it runs right in your browser.`)
};

const zh_vc_ctaband_sub = /** @type {(inputs: Vc_Ctaband_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费、开源，打开浏览器就能用。`)
};

/**
* | output |
* | --- |
* | "Free, open source, and it runs right in your browser." |
*
* @param {Vc_Ctaband_SubInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_ctaband_sub = /** @type {((inputs?: Vc_Ctaband_SubInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Ctaband_SubInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_ctaband_sub(inputs)
	return zh_vc_ctaband_sub(inputs)
});
export { vc_ctaband_sub as "vc.ctaband.sub" }